import { PrintAndSendWizardReduxState, UPDATE_PRINT_AND_SEND_WIZARD_STATE, PrintAndSendWizardActionTypes, SET_STEP_INDEX, NEXT_STEP_INDEX, PREVIOUS_STEP_INDEX, RESET_PRINT_AND_SEND_FIELDS, SET_ACTIVE_ACCORDION_INDEX } from './types'

const resetPrintAndSendFields = (): PrintAndSendWizardActionTypes => {
    return {
        type: RESET_PRINT_AND_SEND_FIELDS,
    }
}

const updatePrintAndSendWizardState = (printAndSendWizardState: Partial<PrintAndSendWizardReduxState>): PrintAndSendWizardActionTypes => {
    return {
        type: UPDATE_PRINT_AND_SEND_WIZARD_STATE,
        payload: printAndSendWizardState
    }
}

const setStepIndex = (stepIndex: number): PrintAndSendWizardActionTypes => {
    return {
        type: SET_STEP_INDEX,
        stepIndex: stepIndex
    }
}

const nextStepIndex = (): PrintAndSendWizardActionTypes => {
    return {
        type: NEXT_STEP_INDEX,
    }
}

const previousStepIndex = (): PrintAndSendWizardActionTypes => {
    return {
        type: PREVIOUS_STEP_INDEX,
    }
}

const setActiveAccordionIndex = (activeAccordionIndex: number): PrintAndSendWizardActionTypes => {
    return {
        type: SET_ACTIVE_ACCORDION_INDEX,
        activeAccordionIndex: activeAccordionIndex
    }
}

export default {
    resetPrintAndSendFields,
    updatePrintAndSendWizardState,
    setStepIndex,
    nextStepIndex,
    previousStepIndex,
    setActiveAccordionIndex
}